import { motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

// Simple scroll reveal: upward drift + fade.
// mount=true -> animate on mount (for above-the-fold hero content).
export function Reveal({ children, delay = 0, y = 30, className = "", as = "div", once = true, mount = false }) {
  const MotionTag = motion[as] || motion.div;
  const trigger = mount
    ? { animate: { opacity: 1, y: 0 } }
    : { whileInView: { opacity: 1, y: 0 }, viewport: { once, margin: "-80px" } };
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      {...trigger}
      transition={{ duration: 0.8, ease: EASE, delay }}
    >
      {children}
    </MotionTag>
  );
}

// Masked line-by-line reveal (kinetic headline). Pass array of lines.
export function KineticHeadline({ lines, className = "", lineClassName = "", delay = 0, once = true, mount = true }) {
  return (
    <span className={className} aria-label={lines.join(" ")}>
      {lines.map((line, i) => {
        const trigger = mount
          ? { animate: { y: "0%" } }
          : { whileInView: { y: "0%" }, viewport: { once, margin: "-40px" } };
        return (
          <span key={i} className="line-mask" aria-hidden="true">
            <motion.span
              className={`block ${lineClassName}`}
              initial={{ y: "110%" }}
              {...trigger}
              transition={{ duration: 0.9, ease: EASE, delay: delay + i * 0.12 }}
            >
              {line}
            </motion.span>
          </span>
        );
      })}
    </span>
  );
}

// Stagger container + item helpers
export function StaggerGroup({ children, className = "", stagger = 0.1, once = true }) {
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount: 0.1 }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: stagger } },
      }}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem({ children, className = "", y = 26, ...rest }) {
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y },
        show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: EASE } },
      }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export { EASE };
